import { useI18n } from '@namespace/i18n';
import { SPORT_IDS } from '../../../../constants';
import { useEventTimerCounters } from '../../../../hooks/useTimerCounter';
import { useEventFields } from '../../../../store';
import EventLabel from '../../../EventLabel';
import { EVENT_RESULT_PENALTY } from '../../../Score/constants';
import TimerCounter from '../../../TimerCounter';
import EventStateLabel from '../EventStateLabel';

import styles from '../../index.module.css';

const EventStateTimer = ({ eventId, emptyStateText, lineView }) => {
  const { t } = useI18n();
  const { eventStatusType, eventTimer, eventResultId, sportId } =
    useEventFields({
      eventId,
      fields: ['eventStatusType', 'eventTimer', 'eventResultId', 'sportId']
    });
  const timerCounters = useEventTimerCounters(eventTimer);

  if (
    (sportId === SPORT_IDS.WATER_POLO_GAME &&
      eventResultId === EVENT_RESULT_PENALTY) ||
    (sportId === SPORT_IDS.PICKLEBALL && eventStatusType === 'inprogress')
  ) {
    return (
      <EventLabel
        className={`${styles.live} ${lineView ? styles[lineView] : ''}`}
        dataRole={`event-${eventId}-label`}
        text={t('sportsBook.eventState.live')}
      />
    );
  }

  return eventTimer ? (
    <EventLabel
      className={`${styles.live} ${lineView ? styles[lineView] : ''}`}
      dataRole={`event-${eventId}-label`}
    >
      <TimerCounter {...timerCounters} />
    </EventLabel>
  ) : (
    (Boolean(emptyStateText) || Boolean(eventStatusType)) && (
      <>
        <EventLabel
          className={`${styles.live} ${lineView ? styles[lineView] : ''}`}
          dataRole={`event-${eventId}-label`}
          text={
            emptyStateText !== ''
              ? emptyStateText
              : t(`sportsBook.eventState.${eventStatusType}`)
          }
        />
        <EventStateLabel eventId={eventId} />
      </>
    )
  );
};

export default EventStateTimer;
